import React,{useMemo,useState}from"react";
import"./executive-compliance.css";

const periods=["3M","6M","9M","12M","18M"] as const;
type Period=typeof periods[number];
type Row={item:string,current:string,previous:string,change:string,status:string,materiality:string};
type Section={title:string;score:number;rows:Row[]};

const sections:Section[]=[
{title:"Business Events",score:87,rows:[
{item:"Opportunities identified",current:"148",previous:"131",change:"+13.0%",status:"On track",materiality:"High"},
{item:"Opportunities executed",current:"63",previous:"54",change:"+16.7%",status:"On track",materiality:"High"},
{item:"Proposed hedges",current:"41",previous:"36",change:"+13.9%",status:"Review",materiality:"Medium"},
{item:"Executed hedges",current:"29",previous:"27",change:"+7.4%",status:"On track",materiality:"High"},
{item:"Compliance factors passed",current:"92.4%",previous:"90.1%",change:"+2.3pp",status:"On track",materiality:"High"},
{item:"Trends and material exceptions",current:"6 open",previous:"9 open",change:"−3",status:"Review",materiality:"High"}]},
{title:"EU IFRS / US GAAP",score:91,rows:[
{item:"Business executed",current:"$1.84bn",previous:"$1.66bn",change:"+10.8%",status:"On track",materiality:"High"},
{item:"Accounting effectiveness passed",current:"94.8%",previous:"93.2%",change:"+1.6pp",status:"On track",materiality:"High"},
{item:"Accounting breaches",current:"3",previous:"5",change:"−2",status:"Review",materiality:"High"},
{item:"Lawsuits",current:"1",previous:"1",change:"—",status:"Monitored",materiality:"High"},
{item:"Legal inquiries / actions",current:"2 · 08 Sep",previous:"3 · 17 Jun",change:"−1",status:"Review",materiality:"High"},
{item:"Trends and material exceptions",current:"4 open",previous:"7 open",change:"−3",status:"Review",materiality:"Medium"}]},
{title:"CBAM Compliance",score:79,rows:[
{item:"Business executed in EU",current:"$684m",previous:"$611m",change:"+11.9%",status:"On track",materiality:"High"},
{item:"Tax and fines",current:"$1.2m",previous:"$0.8m",change:"+$0.4m",status:"Action",materiality:"High"},
{item:"Compliance factors passed",current:"83.6%",previous:"80.2%",change:"+3.4pp",status:"Review",materiality:"High"},
{item:"Engaged counterparties",current:"38",previous:"34",change:"+4",status:"On track",materiality:"Medium"},
{item:"Areas for improvement",current:"7",previous:"9",change:"−2",status:"Action",materiality:"High"},
{item:"Trends and material exceptions",current:"8 open",previous:"11 open",change:"−3",status:"Review",materiality:"High"}]}
];

const periodRatio:Record<Period,number>={"3M":.25,"6M":.4,"9M":.55,"12M":.72,"18M":1};
const scoreAdjustment:Record<Period,number>={"3M":-3,"6M":-2,"9M":-1,"12M":0,"18M":1};

function periodValue(value:string,period:Period){
  const ratio=periodRatio[period];
  if(value==="—"||value.includes("%")||value.includes("pp"))return value;
  const date=value.match(/^([0-9]+)( · .+)$/);
  if(date)return `${Math.max(1,Math.round(Number(date[1])*ratio))}${date[2]}`;
  const amount=value.match(/^([+−-]?\$)([0-9.]+)(bn|m)$/);
  if(amount){
    const scaled=Number(amount[2])*ratio;
    return `${amount[1]}${scaled<10?scaled.toFixed(2):Math.round(scaled)}${amount[3]}`;
  }
  const open=value.match(/^([0-9]+) open$/);
  if(open)return `${Math.max(0,Math.round(Number(open[1])*ratio))} open`;
  const count=value.match(/^([+−-]?)([0-9]+)$/);
  if(count)return `${count[1]}${Math.max(0,Math.round(Number(count[2])*ratio))}`;
  return value;
}

function Gauge({score}:{score:number}){return <div className="ec-gauge" style={{"--score":score}as React.CSSProperties}><div><strong>{score}%</strong><span>Overall score</span></div></div>}

export default function ExecutiveCompliance(){
  const[period,setPeriod]=useState<Period>("3M");
  const visible=useMemo(()=>sections.map(section=>({
    ...section,
    score:Math.max(0,Math.min(100,section.score+scoreAdjustment[period])),
    rows:section.rows.map(row=>({...row,current:periodValue(row.current,period),previous:periodValue(row.previous,period),change:periodValue(row.change,period)}))
  })),[period]);

  return <section className="ec">
    <header><div><small>EXECUTIVE VIEW</small><h1>Executive Compliance</h1></div>
      <nav aria-label="Reporting period">{periods.map(p=><button type="button" aria-pressed={period===p} className={period===p?"active":""} onClick={()=>setPeriod(p)} key={p}>{p}</button>)}</nav>
    </header>
    <div className="ec-sections">{visible.map(section=><article key={section.title}>
      <div className="ec-section__summary"><h2>{section.title}</h2><Gauge score={section.score}/></div>
      <div className="ec-section__table"><table><thead><tr><th>Item</th><th>Current</th><th>Previous</th><th>Change</th><th>Status</th><th>Materiality</th></tr></thead>
        <tbody>{section.rows.map(row=><tr key={row.item}><td>{row.item}</td><td>{row.current}</td><td>{row.previous}</td><td>{row.change}</td><td><span className={row.status.toLowerCase().replace(" ","-")}>{row.status}</span></td><td>{row.materiality}</td></tr>)}</tbody>
      </table></div>
    </article>)}</div>
  </section>
}
